import { createContext, useContext } from "react";

import { TCompanyBilling, TInvoiceDetail } from "@/types";

export interface IInvoiceFormContext {
	invoiceId?: number;
	existing?: TInvoiceDetail;
	/** Issued: every field but the paid mark is read-only. */
	isLocked: boolean;
	/** The issuer's billing settings, for the VAT defaults of a new line. */
	billing?: TCompanyBilling;
	isBusy: boolean;
}

export const InvoiceFormContext = createContext<IInvoiceFormContext | null>(
	null
);

export const useInvoiceForm = () => {
	const context = useContext(InvoiceFormContext);
	if (!context) {
		throw new Error("useInvoiceForm must be used within an InvoiceForm");
	}
	return context;
};
